import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import {
  Button,
  Col,
  ConfigProvider,
  InputNumber,
  Dropdown,
  Form,
  Input,
  Menu,
  MenuProps,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import { CommonStore, SignatureManageStore } from "../../../store";
import dictionary from "../../../utils/dictionary";
import { DownOutlined, MoreOutlined } from "@ant-design/icons";
import RowDetail from "./rowDetail";

function SignatureManage() {
  const [form] = Form.useForm();
  const { Column } = Table;
  const { Option } = Select;

  useEffect(() => {
    form.setFieldsValue({
      no: "",
      templateSignature: null,
    });
    resetSearchBth();
  }, []);
  const getFormData = (changeValue: any, allValues: any) => {
    console.log(changeValue, allValues);

    SignatureManageStore.setSearchForm({ ...allValues });
  };
  const resetSearchBth = () => {
    SignatureManageStore.setSearchForm({});
    searchBtn();
  };
  const searchBtn = () => {
    SignatureManageStore.resetPage();
    SignatureManageStore.getSignaturePage();
  };

  return (
    <Fragment>
      <RowDetail></RowDetail>
        <div className="formContent">
          <Form
            form={form}
            initialValues={SignatureManageStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === "enter") {
                searchBtn();
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="签名编码" name="noId">
                  <Input placeholder="请输入签名编码" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="模版签名" name="templateSignature">
                  <Select
                    allowClear={true}
                    placeholder="请选择模版签名"
                    showSearch
                    optionFilterProp="label"
                    options={
                      SignatureManageStore.getAllEnumList &&
                      SignatureManageStore.getAllEnumList.map((item: any) => ({
                        value: item.templateSignature,
                        label: item.templateSignature,
                      }))
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={SignatureManageStore.tableData.records}
              rowKey={(record) => record.no}
              loading={SignatureManageStore.tableLoad}
              scroll={{ x: 1300 }}
              pagination={{
                current: SignatureManageStore.pageData.page,
                pageSize: SignatureManageStore.pageData.size,
                onChange: SignatureManageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: SignatureManageStore.tableData.total,
                showTotal: () =>
                  `共计${SignatureManageStore.tableData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                fixed="left"
                ellipsis={true}
                width={150}
                title="签名编码"
                dataIndex="no"
                render={(no) => (
                  <Tooltip placement="topLeft" title={no}>{no}</Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={120}
                title="模版签名"
                dataIndex="templateSignature"
                render={(templateSignature) => (
                  <Tooltip placement="topLeft" title={templateSignature}>{templateSignature}</Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={100}
                title="关联模版数量"
                dataIndex="relevanceNumber"
              />
              <Column
                title="有效期"
                width={150}
                dataIndex="expirationDate"
                ellipsis={true}
              />
              <Column
                title="创建人"
                width={120}
                dataIndex="creator"
                ellipsis={true}
              />
              <Column
                title="创建时间"
                width={200}
                dataIndex="createTime"
                ellipsis={true}
              />
              <Column
                width={100}
                fixed={"right"}
                align={"right"}
                render={(text: string, record: any) => (
                  <Space>
                    {CommonStore.pagePermission.readable && (
                      <Button
                        size={"small"} 
                        onClick={() =>
                          SignatureManageStore.openDetailModal(record)
                        }
                      >
                        详情
                      </Button>
                    )}
                    {CommonStore.pagePermission.manageable && (
                      <Button
                        size={"small"}
                        onClick={() =>
                          SignatureManageStore.deletePower(record.no)
                        }
                      >
                        删除
                      </Button>
                    )}
                  </Space>
                )}
              />
            </Table>
          </ConfigProvider>
        </div>
    </Fragment>
  );
}

export default observer(SignatureManage);
